// Constants
import {
  EMPLOYEE_RELATIONSHIP_ROLE_LABEL,
  EmployeeRelationshipRole,
} from '@/constants/employee';
import { ActionType } from '@/constants/action';
import { getActionLabel } from '@/utils/chatbot';

// Types
import type {
  AssignMentorResponse,
  AssignMenteeResponse,
  UnassignMenteeResponse,
  UnassignMentorResponse,
} from '@/types/api';

export const mapMentorAssignmentData = (data: AssignMentorResponse['data']) => {
  const { mentor } = data;
  const { email, username, name, avatar } = mentor;

  return {
    action: ActionType.ASSIGN,
    relationship: EmployeeRelationshipRole.MENTOR,
    target: {
      email,
      username,
      name,
      avatar,
    },
  };
};

export const mapMentorUnassignmentData = (
  data: UnassignMentorResponse['data'],
) => {
  const { unAssignedMentor } = data;
  const { email, username, name, avatar } = unAssignedMentor;

  return {
    action: ActionType.UNASSIGN,
    relationship: EmployeeRelationshipRole.MENTOR,
    target: {
      email,
      username,
      name,
      avatar,
    },
  };
};

export const mapMenteeAssignmentData = (data: AssignMenteeResponse['data']) => {
  const { mentees } = data;

  return {
    action: ActionType.ASSIGN,
    relationship: EmployeeRelationshipRole.MENTEE,
    target: mentees.map(({ email, username, name, avatar }) => ({
      email,
      username,
      name,
      avatar,
    })),
  };
};

export const mapMenteeUnassignmentData = (
  data: UnassignMenteeResponse['data'],
) => {
  const { unAssignedMentees } = data;

  return {
    action: ActionType.UNASSIGN,
    relationship: EmployeeRelationshipRole.MENTEE,
    target: unAssignedMentees.map(({ email, username, name, avatar }) => ({
      email,
      username,
      name,
      avatar,
    })),
  };
};

const getRelationshipRoleLabel = (
  role: EmployeeRelationshipRole,
  count: number,
): string => {
  const baseLabel = EMPLOYEE_RELATIONSHIP_ROLE_LABEL[role];
  const needsPlural =
    count > 1 &&
    (role === EmployeeRelationshipRole.MENTEE ||
      role === EmployeeRelationshipRole.SUPPORTEE);

  return needsPlural ? `${baseLabel}s` : baseLabel;
};

export const getRelationshipCardTitle = (
  action: ActionType,
  relationship: EmployeeRelationshipRole,
  targetCount: number,
): string => {
  const verb = getActionLabel(action);
  const roleLabel = getRelationshipRoleLabel(relationship, targetCount);

  return `${verb} ${roleLabel}`;
};
